import { Navigate, useLocation } from 'react-router-dom';
import { useAuth } from '../context/AuthContext';

interface ProtectedRouteProps {
  children: JSX.Element;
  requireProfile?: boolean;
}

export const ProtectedRoute = ({ children, requireProfile = true }: ProtectedRouteProps) => {
  const { user, profile, loading } = useAuth();
  const location = useLocation();

  if (loading) {
    return (
      <div className="flex justify-center items-center min-h-screen">
        <div className="text-xl font-bold text-gray-600">Memuat...</div>
      </div>
    );
  }

  if (!user) {
    return <Navigate to="/login" replace />;
  }

  if (requireProfile && !profile) {
    return <Navigate to="/complete-profile" replace />;
  }

  // If user has profile but tries to access complete-profile page, redirect to home
  if (!requireProfile && profile) {
    return <Navigate to="/" replace />;
  }

  if (profile) {
    const isDoctorOrAdmin = profile.role === 'doctor' || profile.role === 'superadmin';
    const isPatient = profile.role === 'patient';

    if (isDoctorOrAdmin && location.pathname !== '/dashboard' && location.pathname !== '/about') {
      return <Navigate to="/dashboard" replace />;
    }

    if (isPatient && location.pathname === '/dashboard') {
      return <Navigate to="/" replace />;
    }
  }

  return children;
};
